import { useCallback, useContext, useEffect,useState } from 'react';
import { useTheme } from 'styled-components';
import { WidgetButton as StyledWidgetButton } from './components/widget-button-container';
import { useAppDispatch, useAppSelector } from '../../../common/store';
import { appStateSelector } from '../../../common/store/app-state/selectors';
import { setIsNudgeOpen, setIsOpen } from '../../../common/store/app-state/app-state-slice';
import { OpenChatIcon } from '../../components/icons/open-chat';
import { CrossIcon } from '../../components/icons/cross-icon';
import { sendMessageLogSubmission } from '../../../common/store/chat/thunks/send-message-log';
import VurbalizeEvents from '../../../common/types/dto/chat/vurbalize-events';
import getMessageByVurablizeEvent from '../../utils/get-message-by-vurablize-event';
import { ButtonBlurrer } from '../chat-actions/ButtonBlurrer';
import { ChatContext } from '../../contexts/chat-context';

const WidgetButton = () => {
  const theme = useTheme();
  const storeAppState = useAppSelector(appStateSelector);
  const dispatch = useAppDispatch();
  const { markAllMessagesAsRead } = useContext(ChatContext);
  const [isFocus, setIsFocus] = useState(document.hasFocus());

  
useEffect(() => {
  if (storeAppState.isOpen && !document.hidden && document.hasFocus()) {
    markAllMessagesAsRead();
  }
}, [storeAppState.isOpen, markAllMessagesAsRead, isFocus]);

useEffect(() => {
  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible' && document.hasFocus() && storeAppState.isOpen) {
      markAllMessagesAsRead();
    }
  };

  const handleFocus = () => {
    setIsFocus(true);
    if (document.visibilityState === 'visible' && storeAppState.isOpen) {
      markAllMessagesAsRead();
    }
  };

  const handleBlur = () => {
    setIsFocus(false);
  };

  document.addEventListener('visibilitychange', handleVisibilityChange);
  window.addEventListener('focus', handleFocus);
  window.addEventListener('blur', handleBlur);

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', handleFocus);
    window.removeEventListener('blur', handleBlur);
  };
}, [storeAppState.isOpen, markAllMessagesAsRead]);

  
  
  const handleClick = useCallback(() => {
    const isOpen = !storeAppState.isOpen;
    dispatch(setIsOpen(isOpen));
    dispatch(setIsNudgeOpen(false));
    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.WIDGET_CHAT_ICON_CLICK, isOpen ? 'opened' : 'closed'),
        event_name: VurbalizeEvents.WIDGET_CHAT_ICON_CLICK,
        event_data: {
          timestamp: Date.now(),
          isOpen,
        },
      }
    }))
  }, [storeAppState.isOpen]);
  const openWidgetIconSrc = theme?.themeConfig?.chatButton?.openedIcon?.src;
  const closedWidgetIconSrc = theme?.themeConfig?.chatButton?.closedIcon?.src;
  return (
    <ButtonBlurrer>
      <StyledWidgetButton onClick={handleClick} className="voa_chat_button">
        {storeAppState.isOpen ?
          openWidgetIconSrc !== '/assets/opened-chat-icon.svg' ?
            (<img
              src={openWidgetIconSrc}
              alt="Open Chat Icon"
              width={20}
              height={20}
              style={{ width: '20', height: '20' }}
            />) :
            (<CrossIcon fill="white" width="20px" height="20px" />)
          :
          closedWidgetIconSrc !== '/assets/closed-chat-icon.svg' ?
            (<img
              src={closedWidgetIconSrc}
              alt="Closed Chat Icon"
              width={60}
              height={60}
              style={{ width: '60px', height: '60px'}}
            />) :
            (<OpenChatIcon width="64px" height="64px" />)}
      </StyledWidgetButton>
    </ButtonBlurrer>
  )
};

export default WidgetButton;